<main>
    <div class="container">
        <section class="row Testimonial mt-4" aria-labelledby="Testimonial">
            <ng-container>
                <div class="col-12 mb-4 d-flex justify-content-between align-items-center">
                    <div class="col-auto">
                        <h2 id="testimonial" class="h4">Testimonial</h2>
                    </div>
                </div>
                <div class="col-12 carousel-tiles">
                    <div class="row">
                        <div class="col-4 mb-5" *ngFor="let list of testimonialList">
                            <figure class="col">
                                <a class="position-relative d-block youtube w-100 h-100" data-fancybox
                                    href="https://www.youtube.com/watch?v={{list.url}}?autoplay=1">
                                    <span class="material-icons-outlined font-38 position-absolute play">
                                        play_circle_filled
                                    </span>
                                    <img [src]=" 'http://i3.ytimg.com/vi/' + list.url +'/maxresdefault.jpg' || 'https://media.istockphoto.com/photos/closeup-of-indian-hindu-goddess-lakshmi-idol-in-a-temple-picture-id1224777525?s=2048x2048'"
                                        class="img-fluid mb-3 border-radius" alt="...">
                                </a>
                                <figcaption>
                                    <p class="mb-0 text-truncate col-10 p-0"><strong>{{list.title}}</strong></p>
                                    <p class="truncate-overflow">{{list.description}}</p>
                                </figcaption>
                            </figure>
                        </div>
                    </div>
                    
                </div>
            </ng-container>
        </section>
    </div>
</main>
